import { aclFeatures } from '@/lib/acl/aclFeatures';
import { LAST_3_MONTHS, LAST_30_DAYS, PREVIOUS_MONTH } from '@/lib/periods';
import {
    REPORTS_ACCOUNTS,
    REPORTS_COMPETITORS,
    REPORTS_DASHBOARDS,
    REPORTS_HASHTAGS
} from '@/lib/routes/privateRoutes';

export const REPORT_TYPES = {
    ACCOUNT: 'account',
    DASHBOARD: 'dashboard',
    HASHTAG: 'hashtag',
    COMPETITOR: 'competitor'
} as const;

export type ReportFormTypeConfigType = (typeof reportFormTypesConfig)[number];

const reportFormTypesConfig = [
    {
        type: REPORT_TYPES.ACCOUNT,
        link: REPORTS_ACCOUNTS,
        label: 'reports:general.social_profile',
        icon: 'single-profile',
        formats: ['xls', 'pdf'],
        allowedDatepickerPeriods: 'exports',
        defaultPeriod: PREVIOUS_MONTH,
        contentField: {
            name: 'social_profiles',
            label: 'reports:create.label_social'
        },
        contentIdsQueryName: 'social_profiles'
    },
    {
        type: REPORT_TYPES.DASHBOARD,
        link: REPORTS_DASHBOARDS,
        label: 'reports:general.dashboard',
        icon: 'dashboard',
        formats: ['xls', 'pdf'],
        allowedDatepickerPeriods: 'exports',
        defaultPeriod: PREVIOUS_MONTH,
        contentField: {
            name: 'dashboards',
            label: 'reports:create.label_dashboard'
        },
        contentIdsQueryName: 'dashboards',
        permission: {
            aclRight: aclFeatures.dashboard.base.read
        },
        allowsPartialAccess: true
    },
    {
        type: REPORT_TYPES.HASHTAG,
        link: REPORTS_HASHTAGS,
        label: 'reports:general.hashtag',
        icon: 'hashtag',
        formats: ['xls'],
        allowedDatepickerPeriods: 'exports_max_30_days',
        defaultPeriod: LAST_30_DAYS,
        contentField: {
            name: 'hashtags',
            label: 'reports:create.label_hashtag'
        },
        contentIdsQueryName: 'hashtags',
        permission: {
            aclRight: aclFeatures.listening.hashtag.read
        }
    },
    {
        type: REPORT_TYPES.COMPETITOR,
        link: REPORTS_COMPETITORS,
        label: 'reports:general.competitor',
        icon: 'competitors',
        formats: ['xls'],
        allowedDatepickerPeriods: 'exports_max_90_days',
        defaultPeriod: LAST_3_MONTHS,
        contentField: {
            name: 'social_profiles',
            label: 'reports:create.label_competitor'
        },
        contentIdsQueryName: 'id',
        permission: {
            aclRight: aclFeatures.listening.competitor.create
        }
    }
] as const;

export default reportFormTypesConfig;
